import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";
import AppErrorBoundary from "./components/common/AppErrorBoundary";
import {
  reloadOnceForChunkError,
  reportRenderError,
} from "./utils/renderCrash";

// 1. Design tokens (must be first)
import "./styles/global/GlobalVariables.css";

// 2. Theme system (uses design tokens)
import "./styles/global/theme.css";

// 3. Base element styles
import "./styles/global/GlobalReset.css";

// 4. Layout containers
import "./styles/global/GlobalLayout.css";
import "./styles/global/GlobalMobileApp.css";
import "./styles/global/GlobalSurfaces.css";

// 5. Component systems
import "./styles/global/GlobalButtons.css";
import "./styles/global/GlobalForms.css";
import "./styles/global/GlobalTables.css";

// 6. Special features
import "./styles/global/ReducedMotion.css";

import { CategoryProvider } from "./contexts/CategoryContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { RegionProvider } from "./contexts/RegionContext";
import { SENTRY_DSN, NODE_ENV, isProduction } from "./config/env";

// Sentry error monitoring (production only if DSN provided)
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: NODE_ENV,
    tracesSampleRate: 0.1,
  });
} else if (isProduction) {
  console.error(
    "REACT_APP_SENTRY_DSN is not set. Browser crashes will be logged in the console only.",
  );
}

const handleRenderCrash = (error, errorInfo) => {
  reportRenderError(error, errorInfo, "root");
  reloadOnceForChunkError(error);
};

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onCaughtError: handleRenderCrash,
  onUncaughtError: handleRenderCrash,
});
root.render(
  <AppErrorBoundary>
    <ThemeProvider>
      <RegionProvider>
        <CategoryProvider>
          <App />
        </CategoryProvider>
      </RegionProvider>
    </ThemeProvider>
  </AppErrorBoundary>,
);
